import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import { useAddSmsProviderMutation } from "store/services/smsProviderApi";
import SmsProviderForm from "./components/SmsProviderForm";

const SmsProviderCreateScreen = () => {
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "SMS Providers", path: "/app/crm/sms-provider/list" },
    { title: "New SMS Provider" },
  ];

  // RTK Query hook for adding a new SMS provider
  const [addSmsProvider, { isLoading }] = useAddSmsProviderMutation();

  const handleCreateSmsProvider = async (data) => {
    try {
      const { _id } = await addSmsProvider(data).unwrap();
      toast.success("SMS Provider successfully created!");
      navigate(`/app/crm/sms-provider/${_id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't create SMS Provider!"
      );
    }
  };

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={isLoading}>
      <BreadcrumbLayout.Paper>
        <SmsProviderForm
          isBusy={isLoading}
          onSubmit={handleCreateSmsProvider}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default SmsProviderCreateScreen;